/* Publish by EComposer at 2026-10-17 19:04:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mu8o4ihurbf"]=  window.__ectimmers["ecom-mu8o4ihurbf"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mu8o4ihurbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mu8o4ihurbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klkzvfnv58d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klkzvfnv58d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnoxxdtdmsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnoxxdtdmsd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0if8cu1vnufj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0if8cu1vnufj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdqgpmgvz5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdqgpmgvz5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gfnw3bfwa1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gfnw3bfwa1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l80kp7iqztm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l80kp7iqztm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8v63a1r02zn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8v63a1r02zn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpsbv6u7pam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpsbv6u7pam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4swhece8ihj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4swhece8ihj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frylxrpkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frylxrpkp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8kp00v62y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8kp00v62y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jcm36g1pmrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jcm36g1pmrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7d3lsqtg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7d3lsqtg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f27pncskthu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f27pncskthu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4k7qwi63ja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4k7qwi63ja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fsn4a3gehw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fsn4a3gehw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mp9xwdldljo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mp9xwdldljo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20mbqaaboxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20mbqaaboxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6syr34bv3z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6syr34bv3z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aw7ydj1kry').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw7ydj1kry', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-576xcrsnfxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-576xcrsnfxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qf4zuluwlcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qf4zuluwlcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgn4c54n9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgn4c54n9l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eqw710j11c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eqw710j11c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vo2q64ir8x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vo2q64ir8x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-watm49gory').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-watm49gory', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1nuyrgxibvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1nuyrgxibvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ai69fdjiqgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ai69fdjiqgn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wllrixnzuqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wllrixnzuqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6furnd5y3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6furnd5y3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iccuio6mzce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iccuio6mzce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34gsf7nuv9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34gsf7nuv9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtfnvebwb9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtfnvebwb9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tbfcrvowbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tbfcrvowbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c280q9ddg6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c280q9ddg6c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4w8cht20fvx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4w8cht20fvx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5ie0z69gra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5ie0z69gra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ei3w2btl2iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ei3w2btl2iq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwm2yj0yom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwm2yj0yom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o399fwpttfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o399fwpttfc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptmwwt1a7hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptmwwt1a7hj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z87itvhagnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z87itvhagnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10ru8f0s0gns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10ru8f0s0gns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rqxq19g5xas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqxq19g5xas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rl8ss7rjpam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl8ss7rjpam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m96l6c4cdbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m96l6c4cdbd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xfjaad1er7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xfjaad1er7m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4xeccvkh5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4xeccvkh5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-seras7zjzrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-seras7zjzrc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-haadpujssut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-haadpujssut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p634yu9traf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p634yu9traf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1tfg753ed24').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tfg753ed24', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uto5i0jyhsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uto5i0jyhsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgeczn5w21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgeczn5w21', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8p177k4d0xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8p177k4d0xj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgph5qzdqdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgph5qzdqdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0f9iak9jpukm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0f9iak9jpukm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czs9tcezxf6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czs9tcezxf6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzssyezmwvq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzssyezmwvq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l596g9v1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l596g9v1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffjiwvrh5ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffjiwvrh5ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4c8y13r35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4c8y13r35', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18a31te90t6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18a31te90t6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ug1pgl9l4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ug1pgl9l4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0734v05dbnpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0734v05dbnpn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n0i7lbmqq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0i7lbmqq7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zf6mp03z6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zf6mp03z6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-88g6z5kgvga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88g6z5kgvga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1gtr5bquog4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1gtr5bquog4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwnabb1b57s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwnabb1b57s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8rfbjq2rq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8rfbjq2rq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8b3kc6aqed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8b3kc6aqed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hkdszejs8je').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hkdszejs8je', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nr9qkp0aq9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nr9qkp0aq9l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uyormymq1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyormymq1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g50rinr41').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g50rinr41', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyzae49u708').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyzae49u708', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36wi0qx2qut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36wi0qx2qut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vef3ongblo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vef3ongblo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5oi0sefpkv5"]=  window.__ectimmers["ecom-5oi0sefpkv5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-5oi0sefpkv5"]["fccuwtff4"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-5oi0sefpkv5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5oi0sefpkv5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bwbl1vjbm66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bwbl1vjbm66', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jb8ghelmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jb8ghelmo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lowh8xvjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lowh8xvjk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouia0aj1v6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouia0aj1v6i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uahznd0qq6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uahznd0qq6b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3krccsrn4bq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3krccsrn4bq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eb8jscpziap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eb8jscpziap', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mfhg3qolihg"]=  window.__ectimmers["ecom-mfhg3qolihg"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+e);n.length&&n.forEach(function(r){const a=r.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const l=r.querySelector("video");l!=null&&l.pause()})},s=function(n){if(window.EComModal)return n();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&n()});return}let r=0;const a= window.__ectimmers["ecom-mfhg3qolihg"]["p5f9kd2dz"] = setInterval(function(){window.EComModal?(clearInterval(a),n()):++r>=300&&clearInterval(a)},50)},o=this.id;t&&s(function(){var n=t.querySelector("[ecom-modal]");new window.EComModal(n,{cssClass:["ecom-container-lightbox-"+o,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const r=document.querySelectorAll(".ecom-container-lightbox-"+e);r.length&&(r.forEach(function(a){const l=a.querySelector("iframe");if(l!=null){const d=l.src.replace("muted=1","muted=0").replace("mute=1","mute=0");l.src=d}const c=a.querySelector("video");c!=null&&c.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:r}})))},onClose:i})}),i()

                    });
                    
                        document.querySelectorAll('.ecom-mfhg3qolihg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfhg3qolihg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-om507glmtsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-om507glmtsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-849xe9ufxbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-849xe9ufxbh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jahgl6hb2tl"]=  window.__ectimmers["ecom-jahgl6hb2tl"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jahgl6hb2tl"]["dmdcyi9ga"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-jahgl6hb2tl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jahgl6hb2tl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pecyvt1koz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pecyvt1koz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sdeff05lv3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdeff05lv3g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}